module.exports = __webpack_public_path__ + "img/douyin.de000224.png";